import { getBffLogicalDeviceByIdV1ResponseMock } from '@ingenico/api-sdk-provisioning-private/mocks';
import type { GetBffLogicalDeviceByIdV1QueryResponseApi } from '@ingenico/api-sdk-provisioning-private';
import { enumMultiMerchantResourceRole } from '@ingenico/api-sdk-provisioning-private';
import { faker } from '@faker-js/faker';
import { HttpResponse } from 'msw';

// Route: GET bff/logical-devices/{logicalDeviceId}
export function getBffLogicalDeviceByIdV1CustomHandler() {
  return HttpResponse.json<GetBffLogicalDeviceByIdV1QueryResponseApi>({
    ...getBffLogicalDeviceByIdV1ResponseMock(),
    multiMerchant: {
      logicalDeviceRole: enumMultiMerchantResourceRole.PRIMARY,
      multiMerchantConfigurationId: faker.string.uuid(),
      primaryLogicalDeviceId: faker.string.uuid(),
    },
  });
}
